import React, { useRef, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled, { createGlobalStyle } from 'styled-components';
import { CalendarFilter } from '../../../Common/SvgIcon/CommonSvgIcons';

// Sample SVG icon inline (you can replace it with your actual SVG code)
const CalendarSVGIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 0C2.897 0 2 .897 2 2v20c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2H4zm1 2h14c.552 0 1 .448 1 1v3H4V3c0-.552.448-1 1-1zm15 4v16H4V7h16z'
      fill='#666'
    />
  </svg>
);

const DatePickerStyles = createGlobalStyle`
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: #57A177 !important;
    color: white !important;
  }

  .react-datepicker__day:hover {
    background-color: #81c784 !important;
    color: black !important;
  }

  .react-datepicker__day--today {
    border: 1px solid #4caf50;
    font-weight: bold;
  }

  .react-datepicker__day--outside-month {
  visibility: hidden;
}

`;

const InputWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: ${(props) => (props.width ? props.width : '90%')};
`;

const StyledInput = styled.input`
  width: 95%;
  color: ${(props) => (props.color ? 'rgba(99, 99, 99, 1)' : 'black')};
  min-height: 30px;
  padding: 8px 30px 8px 10px;
  font-family: Inter;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    outline: 1px solid green;
  }
`;

const CalendarIconWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 60%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
`;

const CustomInput = forwardRef(
  (
    { value, onClick, placeholder, readOnly, color, style, customIcon },
    ref
  ) => (
    <InputWrapper onClick={onClick}>
      <StyledInput
        ref={ref}
        onClick={onClick}
        value={value}
        readOnly={readOnly}
        placeholder={placeholder}
        color={color}
        style={style}
        disabled={true}
      />
      <CalendarIconWrapper onClick={onClick}>
        {customIcon ? customIcon : CalendarFilter}
      </CalendarIconWrapper>
    </InputWrapper>
  )
);

const CalendarDatePicker = ({
  value,
  dateHandler,
  format = 'dd-MM-yyyy',
  min,
  max,
  name,
  width = '100%',
  color = false,
  readOnlyvalue = false,
  style = {},
  placeholder = 'DD/MM/YY',
  customIcon = null,
}) => {
  const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date.getTime());
  };

  const validateDate = (date) => {
    const start = new Date(min);
    const end = new Date(max);
    const target = new Date(date);
    return isValidDate(start) && isValidDate(end) && isValidDate(target)
      ? target >= start && target <= end
      : false;
  };

  const changeDate = (date) => {
    if (validateDate(date)) {
      dateHandler({ value: date, name });
    } else {
      dateHandler({ value: name === 'firstPostDate' ? min : max, name });
    }
  };

  return (
    <>
      <DatePickerStyles />
      <DatePicker
        selected={value}
        onChange={(date) => changeDate(date)}
        dateFormat={format}
        minDate={min}
        maxDate={max}
        placeholderText={placeholder}
        customInput={
            <CustomInput
              placeholder={placeholder}
              color={color}
              readOnly={true}
              style={style}
              customIcon={customIcon}
            />
        }
      />
    </>
  );
};

export default CalendarDatePicker;
